// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"nP","checkbox":"nQ","labelText":"nR","optText":"nS"};